module.exports = __webpack_public_path__ + "media/images/mammal-78cbdb564fecf4f84ac54e705e4c1d1e.jpeg";